import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import {MitgliedschaftComponent} from "./components/pages/mitgliedschaft/mitgliedschaft.component";
import {TeamComponent} from "./components/common/team/team.component";
import {AboutComponent} from "./components/common/about/about.component";
import {FaqComponent} from "./components/common/faq/faq.component";
import {ContactComponent} from "./components/common/contact/contact.component";
import {SatzungComponent} from "./components/pages/satzung/satzung.component";
import {PatenschaftComponent} from "./components/pages/patenschaft/patenschaft.component";
import {ImpressumComponent} from "./components/pages/impressum/impressum.component";
import {SpendeComponent} from "./components/pages/spende/spende.component";
import {DatenschutzComponent} from "./components/pages/datenschutz/datenschutz.component";
import {RapportsComponent} from "./components/pages/rapports/rapports.component";
import {BlogPageComponent} from "./components/pages/blog-page/blog-page.component";
import {BlogDetailsComponent} from "./components/pages/blog-details/blog-details.component";

const routes: Routes = [
    {path: '', component: HomeOneComponent},
    {path: 'ueber-uns', component: AboutComponent},
    {path: 'mitgliedschaft', component: MitgliedschaftComponent},
    {path: 'team', component: TeamComponent},
    {path: 'faq', component: FaqComponent},
    {path: 'satzung', component: SatzungComponent},
    {path: 'kontakt', component: ContactComponent},

    {path: 'patenschaft', component: PatenschaftComponent},
    {path: 'impressum', component: ImpressumComponent},
    {path: 'spende', component: SpendeComponent},
    {path: 'rapports', component: RapportsComponent},
    {path: 'datenschutz', component: DatenschutzComponent},
    {path: 'projects', component: BlogPageComponent, data: { type: 'PROJECT' }},
    {path: 'blog', component: BlogPageComponent, data: { type: 'BLOG' }},
    {path: 'blog/:type/:id', component: BlogDetailsComponent},
    {path: '**', component: HomeOneComponent},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
